import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class SubscriptionPopupEmailUseCase extends BaseUseCase {
    constructor(repo) {
        super();
        this.repo = repo;
    }
    async fetchResult(req) {
        return await this.repo.emailSubscriptionPopup(req);
    }
}
export default SubscriptionPopupEmailUseCase;
